var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll-page"},[_c('page-title',{attrs:{"showExport":""}},[_vm._v(_vm._s(_vm.$t('polls.info')))]),_vm._v(" "),_c('ui-tabs',{attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }